import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { NotificationsService } from './shared/services/notifications.service';
import { CookieService } from 'ngx-cookie-service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { parseAndDecodeCookieAccessToken } from './auth/cookie';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'HitWeb';

  constructor(
    private titleService: Title,
    private messageService: MessageService,
    private notificationService: NotificationsService
  ) {
    this.titleService.setTitle($localize`${this.title}`);
  }
  ngOnInit(): void {
    this.notificationService.alert$.subscribe((res: any) => {
      this.messageService.add({
        severity: res.type,
        summary: res.summary,
        detail: res.message,
      });
    });

    this.notificationService.startSessionNotifications();
  }
}
